
import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, ArrowUpRight } from "lucide-react";
import Brand from "./Brand";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-slate-900 bg-[#050B14] pt-12 sm:pt-16 pb-8"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 sm:px-6 lg:px-10">
        {/* Main footer content */}
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-6 lg:gap-8 xl:gap-10">
          {/* Brand and contact information */}
          <div className="min-w-0 sm:col-span-2 lg:col-span-2">
            <Brand size="md" />

            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              AI-enabled operations partner for growing businesses.
              Recruiting (RPO), operations (BPO), and knowledge work (KPO) —
              run by trained specialists, accountable end-to-end.
            </p>

          

            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://www.linkedin.com/in/sahil-batra-97410059/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                aria-label="LinkedIn"
                className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-800 text-slate-400 transition-colors hover:border-[#00E5FF]/60 hover:text-[#00E5FF]"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="min-w-0">
            <h2 className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#00E5FF]">
              Services
            </h2>

            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li>
                <Link to="/services/rpo" className="break-words hover:text-white transition-colors">
                  RPO — Recruitment
                </Link>
              </li>
              <li>
                <Link to="/services/bpo" className="break-words hover:text-white transition-colors">
                  BPO — Operations
                </Link>
              </li>
              <li>
                <Link to="/services/kpo" className="break-words hover:text-white transition-colors">
                  KPO — Data &amp; Research
                </Link>
              </li>
              <li>
                <Link to="/ai" className="break-words hover:text-white transition-colors">
                  AI at A4 Assist
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="min-w-0">
            <h2 className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#00E5FF]">
              Company
            </h2>

            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/industries" className="hover:text-white transition-colors">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="hover:text-white transition-colors">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-white transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact us" className="hover:text-white transition-colors">
                  Contact us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact CTA */}
          <div className="min-w-0 sm:col-span-2 lg:col-span-2">
            <h2 className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#00E5FF]">
              Start
            </h2>

            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Curious what an operating partner would look like for your
              business?
            </p>

            <Link
              to="/contact"
              className="group mt-4 inline-flex max-w-full items-center gap-1.5 text-sm font-semibold text-white transition-colors hover:text-[#00E5FF]"
            >
              <span>Book a consultation</span>
              <ArrowUpRight
                size={14}
                className="shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </Link>
              <div className="mt-6 flex flex-col items-start gap-3 text-sm text-slate-400">
              <a
                href="mailto:sahil@a4assist.com"
                data-testid="footer-email"
                className="inline-flex max-w-full items-start gap-2 break-all hover:text-[#00E5FF] transition-colors"
              >
                <Mail size={14} className="mt-1 shrink-0" />
                <span>sahil@a4assist.com</span>
              </a>

              <a
                href="tel:+17185771378"
                data-testid="footer-phone"
                className="inline-flex items-center gap-2 hover:text-[#00E5FF] transition-colors"
              >
                <Phone size={14} className="shrink-0" />
                <span>+1 718 577 1378</span>
              </a>
            </div>
          </div>
        </div>
       

        {/* Copyright */}
        <div className="mt-12 flex flex-col gap-3 border-t border-slate-900 pt-6 text-xs leading-relaxed text-slate-500 sm:mt-16 sm:flex-row sm:items-center sm:justify-between">
          <span>
            © {new Date().getFullYear()} A4 Assist. Operations, done well.
          </span>

          <span className="sm:text-right">
            Built for teams who want capacity, not headcount.
          </span>
        </div>
      </div>
    </footer>
  );
}
